import { QueryRender } from "@/components/helpers/QueryRender"
import { UserAvatar } from "@/components/user/UserAvatar"
import { useAuth } from "@/hooks/useAuth"
import { useAttendanceEvents } from "@/entities/attendanceEvent/useAttendanceEvent"
import { Link } from "react-router-dom"
import CalendarWidget from "@/components/attendance/CalendarWidget"

export default function HomePage() {
   const { user, ...query } = useAuth()
   const { data: attendanceEvents } = useAttendanceEvents({
      young_id: user?.id || "",
      optionWhereNotJustified: true,
   })

   return (
      <QueryRender query={query} data={user}>
         {(user) => (
            <div className="container mx-auto py-6">
               <div className="bg-white shadow rounded-lg p-5">
                  <div className="flex items-center gap-4 mb-6 ">
                     <UserAvatar
                        photo={user.photo}
                        name={`${user.firstName} ${user.lastName}`}
                        size="lg"
                     />
                     <div>
                        <h1 className="text-2xl font-bold">Bonjour {user.firstName} !</h1>
                        <p className="text-gray-600">Groupe : {user.group}</p>
                     </div>
                  </div>

                  <div className="">
                     <div>
                        <CalendarWidget youngId={user.id} />
                     </div>

                     <div>
                        <h2 className="text-lg font-semibold mb-3">Actions rapides</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                           <Link
                              to="/jeune/a-justifier"
                              className={`card bg-base-100 shadow-md hover:shadow-lg ${attendanceEvents?.length ? "border-2 border-error" : ""}`}
                           >
                              <div className="card-body">
                                 <h3 className="card-title flex gap-2">
                                    Absences et retards à justifier
                                    {attendanceEvents?.length ? (
                                       <span className="badge badge-error">
                                          {attendanceEvents.length}
                                       </span>
                                    ) : null}
                                 </h3>
                                 <p>Consultez et justifiez vos absences et retards</p>
                              </div>
                           </Link>
                           <Link
                              to="/jeune/nouvelle-demande-absence"
                              className="card bg-base-100 shadow-md hover:shadow-lg"
                           >
                              <div className="card-body">
                                 <h3 className="card-title">Demander une absence</h3>
                                 <p>Faites une demande d'absence à l'avance</p>
                              </div>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         )}
      </QueryRender>
   )
}
